import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAura: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="aura, enlighten"><circle cx="12" cy="10.5" r="2.75" stroke="currentColor" strokeWidth="1.5"/><path d="M6.75 21V21.25H17.25V21C17.25 18.1005 14.8995 15.75 12 15.75C9.10051 15.75 6.75 18.1005 6.75 21Z" stroke="currentColor" strokeWidth="1.5"/><path d="M12.0002 1V4M5.89369 3.22228L7.82205 5.52041M2.64453 8.85042L5.59895 9.37137M3.77289 15.2502L6.37096 13.7502M18.1066 3.22228L16.1783 5.52041M21.3558 8.85042L18.4014 9.37137M20.2274 15.2502L17.6294 13.7502" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconAura;
